import React, { useState, useEffect, useRef, useContext } from "react";
import moment from "moment";
import { Container, Row, Col,Label, NavLink  } from "reactstrap";
import { MDBIcon, MDBTabs,MDBTabsItem,MDBTabsLink,MDBTabsContent,MDBTabsPane} from "mdb-react-ui-kit";
import {Decimal} from 'decimal.js';
import CloseIcon from '@mui/icons-material/Close';
import { NavLink as RRNavLink, Outlet } from "react-router-dom";
import StoreContext from "./../Store/Context";
import { CLOSE_IMAGE } from "../Image";
import { res, validate } from 'react-email-validator';
import {CotizacionModal } from "./../Modal";
import {IconButton } from "@mui/material";
import { FIND_DESC } from "./../Util";
import LocalPrintshopIcon from "@mui/icons-material/LocalPrintshop";
import {ComponentToPrintsCotizacion} from "../../Inventario/ComponentToPrintss";
import {STATES_COT_COTIZACION} from "../States";
import {DATATABLE_COTIZACION} from "../Datatables"
import {get_re_retencion, get_gr_garantia,delete_cotd_cotizacion_detail,post_cotd_cotizacion_detail_row,put_cot_cotizacion_encabezado,put_cot_cotizacion_sts,
  get_articulo_by_code,get_cli_cliente, get_list_items, post_cli_cliente, put_cli_cliente,put_cotd_cotizacion_detalle_row, get_cotd_cotizacion_detail, 
  post_cot_cotizacion, get_all_cotizacion, 
  post_pdf_cotizacion,
  IP_IMAGENES,
  IP,
  consultar_ruc,
  get_itbms} from "../Services";

export const Cotizacion = () => {
  var componentRef = useRef();
  const { dataCompania,usr_id,usr_sucursal,usr_precio,compania,usr_key_login,quitToken} = useContext(StoreContext);
  const [dataGarantia, setDataGarantia] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [iconsActive, setIconsActive] = useState("tab1");
  const [isPrinting, setPrintI] = useState(false);
  const [isTabAddClientes, setTabAddClientes] = useState(false);
  const [isSaveI, setSaveI] = useState(false);
  const [error_upc, setError_upc] = useState("");
  const [dataCliente, setDataCliente] = useState([]);
  const [dataCotizacion, setDataCotizacion] = useState([]);
  const [dataItems, setDataItems] = useState([]);
  const [basicModal, setBasicModal] = useState(false);
    const [dataItbms, setDataItbms] = useState([]);
  const [basicModalEdit, setBasicModalEdit] = useState(false);
  const [OBJCotizacionDetalle, setOBJCotizacionDetalle] = useState([]);
  // const [formCompania, setFormCompania] = useState(STATES_COT_COTIZACION({staneName:"formCompania"}));
  const [formCotCotizacion, setFormCotCotizacion] = useState(STATES_COT_COTIZACION({staneName:"formCotCotizacion"}));
  const [formCotCotizacionDetalle, setFormCotCotizacionDetalle] = useState(STATES_COT_COTIZACION({staneName:"formCotCotizacionDetalle"}));
  const [formClientes, setFormClientes] = useState(STATES_COT_COTIZACION({staneName:"formClientes"}));
  const [formPrecio, setFormPrecio] = useState(STATES_COT_COTIZACION({staneName:"formPrecio"}));
  const [dataRetencion, setDataRetencion] = useState([]);
  const handleIconsClick = (value) => {
    if (value === iconsActive) {
      return;
    }
    setIconsActive(value);
  };
  async function fetch_cot_cotizacion() {
    var response = await get_all_cotizacion({usr_sucursal});
    setDataCotizacion(response);
  }
  
  async function fetchReRetencion() {
    var response = await get_re_retencion();
    setDataRetencion(response);
  }
  
  async function print_pdf_cotizacion({cotizacion_detalle,formCotizacion}) {

      if (formCotizacion.cli_exento === "1") {
        cotizacion_detalle = cotizacion_detalle.map((data) => ({
          ...data,
          art_itbm_venta: "0.00",
          cotd_itbms:"0.00",
          cotd_total:new Decimal(data.cotd_total).minus(new Decimal(data.cotd_itbms))
        }));
      }
    var body ={
      props:cotizacion_detalle,
      dataCompania:dataCompania,
      form:formCotizacion,
      url:IP_IMAGENES
    
    }
    
     post_pdf_cotizacion(body);
    setTimeout(() => {
        window.open( IP+"/sys_mbo/uploads/pdf/cotizaciones/cotizacion_"+formCotizacion.cot_id+".pdf?"+moment(new Date()).format("YYYYMMDDHHmmss"));
    }, 1000);

  }

  async function post_cotd_cotizacion_detail({body}) {
    var response = post_cotd_cotizacion_detail_row(body);
    response.then((data) => {
      setError("");
      if(data===true)
        fetchCotdDetalle({print:false,cotd_identificador:body.cotd_identificador,formCotizacion:[]})
      else
        setError("ERROR "+data);
    });
  }

  async function put_cotd_cotizacion_detail_({body}) {
    var result = put_cotd_cotizacion_detalle_row(body);
    result.then((data) => {
      setError("");
      if(data===true)
        fetchCotdDetalle({print:false,cotd_identificador:body.cotd_identificador,formCotizacion:[]})
      else
        setError("ERROR "+data);
    });
  }

  async function fetchGarantia() {
    var response = await get_gr_garantia();
    setDataGarantia(response);
  }

  async function fetchCliente() {
    var response = await get_cli_cliente(usr_sucursal);
    setDataCliente(response);
  }

  async function fetch_list_items() {
    var response = await get_list_items(usr_sucursal);
    setDataItems(response);
  }

  async function fetchArticuloByUpc(art_upc) {
    var response = await get_articulo_by_code(art_upc,usr_sucursal);
    if (response[0] !== undefined) {
      setFormPrecio({
        art_precio:response[0].art_precio,
        art_precio2:response[0].art_precio2,
        art_precio3:response[0].art_precio3,
      })
      setError_upc("");
      setFormCotCotizacionDetalle({
        ...formCotCotizacionDetalle,
        cotd_articulo: response[0].art_id,
        art_descripcion: response[0].art_descripcion,
        art_upc: response[0].art_upc,
        cotd_precio: response[0].art_precio,
        art_itbm_cod_v: response[0].art_itbm_cod_v,
        art_itbm_venta:response[0].art_itbm_venta,
        cotd_cantidad:"1",
        art_imgName:response[0].art_imgName,
        art_img:response[0].art_img,
        art_referencia:response[0].art_referencia,
      });
    } else {
      setError_upc("Articulo no existe");
    }
  }
  async function fetchItbms() {
    var response = await get_itbms();
    setDataItbms(response);
  }
  useEffect(() => {
    fetchCliente();
    fetch_list_items();
    fetch_cot_cotizacion();
    fetchItbms();
    if(dataCompania.count ==="0"){
      quitToken()
    }
    fetchGarantia();
    fetchReRetencion();
  }, []);

  const selectCliente = (row) => {
    setFormClientes({
      ...formClientes,
      cli_id: row.original.cli_id,
      cli_nombre: row.original.cli_nombre,
      cli_ruc: row.original.cli_ruc,
      cli_direccion: row.original.cli_direccion,
      cli_telefono: row.original.cli_telefono,
      cli_telefono2: row.original.cli_telefono2,
      cli_dv:row.original.cli_dv,
      cli_email:row.original.cli_email,
      cli_limitc:row.original.cli_limitc,
      cli_credito:row.original.cli_credito,
      cli_exento:row.original.cli_exento,
      cli_retencion:row.original.cli_retencion,
      cli_suc: row.original.cli_suc,
      cli_sts: row.original.cli_sts,
      re_id:row.original.cli_retencion,
      re_desc:dataRetencion.find((item) => item.re_id === row.original.cli_retencion)?.re_desc ?? "",
    });
    setError("");
  };

  const onClickDeleteCotizacion_sts = ({ cot_id, cot_status }) => {
    var body = {
      cot_id,
      cot_status,
    };

    var result = put_cot_cotizacion_sts(body);
    result.then((data) => {
      setError("");
      if(data===true)
        fetch_cot_cotizacion();
      else
        setError("ERROR "+data);
    });
  };
  
  function onChangeCot_CotizacionDetalle(event) {
    const { value, name } = event.target;
    setFormCotCotizacionDetalle({
      ...formCotCotizacionDetalle,
      art_descripcion: name === "art_upc" ? "" : formCotCotizacionDetalle.art_descripcion,
      cotd_precio: name === "art_upc" ? "" : formCotCotizacionDetalle.cotd_precio,
      cotd_cantidad: name === "art_upc" ? "" : formCotCotizacionDetalle.cotd_cantidad,
      art_referencia: name === "art_upc" ? "" : formCotCotizacionDetalle.art_referencia,
      [name]: value,
    });

    setError("");
    setError_upc("");
  }

  const deleteRow = (row) => {
    var value = OBJCotizacionDetalle.filter((data, i) => {
      if (i !== row.index) return data;
    });
    setOBJCotizacionDetalle(value);
    if(basicModalEdit){
      var body ={
        cotd_id:row.original.cotd_id
      }
      delete_cotd_cotizacion_detail(body)
    }
  };

  const onBlurF = (event, row) => {
    var data = OBJCotizacionDetalle.filter((datos, i) => {
      if (i !== row.index) {
        return datos;
      }
    });
    setOBJCotizacionDetalle((OBJCotizacionDetalle) => [
      ...data,
      ...[
        {
          art_descripcion: row.original.art_descripcion,
          cotd_cantidad: event.target.value,
          cotd_itbms: row.original.cotd_itbms,
          cotd_precio: row.original.cotd_precio,
          cotd_total: row.original.cotd_total,
          cotd_articulo: row.original.cotd_articulo,
        },
      ],
    ]);
  };

  function handleKeyPress(event) { 
    const { value, name } = event.target;
    if (event.key === "Enter" && name === "art_upc") {
      fetchArticuloByUpc(value);
    }
    if (event.key === "Enter" && name === "cotd_cantidad" || event.key ===undefined) {
      var flag = false;
      var itbms=0;
      var total =0;
      var cantidad =0;
      var cotd_id ="";
      var objItems = OBJCotizacionDetalle.map((data, i) => {
        if (data.cotd_articulo === formCotCotizacionDetalle.cotd_articulo && data.art_descripcion === formCotCotizacionDetalle.art_descripcion) {
          cantidad = Number(data.cotd_cantidad) + Number(formCotCotizacionDetalle.cotd_cantidad);
          itbms = (new Decimal(cantidad).times(new Decimal(data.cotd_precio))).times(new Decimal(data.art_itbm_venta));
          
          total = ((Number(cantidad)*Number(data.cotd_precio)) + Number(itbms)).toFixed(4);
          flag = true;
          data.cotd_cantidad =cantidad;
          data.cotd_itbms =  itbms;
          data.cotd_total = (new Decimal(cantidad).times(new Decimal(formCotCotizacionDetalle.cotd_precio))).plus(new Decimal(itbms));
          cotd_id = data.cotd_id;
        }
        return data;
      });
      if (!flag) {
        itbms = (new Decimal(formCotCotizacionDetalle.cotd_cantidad).times(new Decimal(formCotCotizacionDetalle.cotd_precio))).times(new Decimal(formCotCotizacionDetalle.art_itbm_venta));

        total = ((Number(formCotCotizacionDetalle.cotd_cantidad)*Number(formCotCotizacionDetalle.cotd_precio))+(Number(itbms))).toFixed(4);
        setOBJCotizacionDetalle([...OBJCotizacionDetalle, ...[{...formCotCotizacionDetalle,
          cotd_itbms:itbms,
          cotd_total:(new Decimal(formCotCotizacionDetalle.cotd_cantidad).times(new Decimal(formCotCotizacionDetalle.cotd_precio))).plus(new Decimal(itbms)),
        }]]);
        if(basicModalEdit){
          var body ={
            cotd_identificador: formCotCotizacion.cot_identificador,
            cotd_sucursal:usr_sucursal,
            cotd_articulo: formCotCotizacionDetalle.cotd_articulo,
            cotd_cantidad: formCotCotizacionDetalle.cotd_cantidad,
            cotd_descuento: formCotCotizacionDetalle.cotd_descuento,
            cotd_descuento_number: formCotCotizacionDetalle.cotd_descuento_number,
            cotd_precio: formCotCotizacionDetalle.cotd_precio,
            cotd_itbms:itbms,
            cotd_total:(new Decimal(formCotCotizacionDetalle.cotd_cantidad).times(new Decimal(formCotCotizacionDetalle.cotd_precio))).plus(new Decimal(itbms)),
            cotd_art_descripcion:formCotCotizacionDetalle.art_descripcion,
          }
          post_cotd_cotizacion_detail({body})
        }

      } else {
        setOBJCotizacionDetalle(objItems);
        if(basicModalEdit){
          var body ={
            cotd_id:cotd_id,
            cotd_identificador: formCotCotizacion.cot_identificador,
            cotd_articulo: formCotCotizacionDetalle.cotd_articulo,
            cotd_cantidad: cantidad,
            cotd_descuento: formCotCotizacionDetalle.cotd_descuento,
            cotd_descuento_number: formCotCotizacionDetalle.cotd_descuento_number,
            cotd_precio: formCotCotizacionDetalle.cotd_precio,
            cotd_itbms:itbms,
            cotd_total:(new Decimal(formCotCotizacionDetalle.cotd_cantidad).times(new Decimal(formCotCotizacionDetalle.cotd_precio))).plus(new Decimal(itbms)),
            cotd_art_descripcion:formCotCotizacionDetalle.art_descripcion,
          }
          put_cotd_cotizacion_detail_({body})
        }
      }
      setFormCotCotizacionDetalle(STATES_COT_COTIZACION({staneName:"formCotCotizacionDetalle"}));
    }
    setError("");
  }

  const onClickNuevaCotizacion = () => {
    setBasicModalEdit(false)
    setBasicModal(true);
    setOBJCotizacionDetalle([]);
    setFormCotCotizacionDetalle(STATES_COT_COTIZACION({staneName:"formCotCotizacionDetalle"}));
    setFormCotCotizacion(STATES_COT_COTIZACION({staneName:"formCotCotizacion"}));
     setFormClientes(STATES_COT_COTIZACION({staneName:"formClientes"}))
  };


  const onClickSaveCotizacion = () => {
    setLoading(true);
    if (OBJCotizacionDetalle[0] !== undefined) {
      var dataCOT_detail = OBJCotizacionDetalle.map((val, i) => {
        return {
          cotd_identificador: formCotCotizacion.cot_identificador,
          cotd_articulo: val.cotd_articulo,
          cotd_art_descripcion:val.art_descripcion,
          cotd_precio: val.cotd_precio,
          cotd_cantidad: val.cotd_cantidad,
          cotd_itbms: Number(val.cotd_itbms).toFixed(4),
          cotd_descuento: val.cotd_descuento,
          cotd_total: Number(val.cotd_total).toFixed(4),
          cotd_descuento_number: val.cotd_descuento_number,
          cotd_sucursal:usr_sucursal
        };
      });

      var body = {
        formCotCotizacion: {
          cot_identificador: formCotCotizacion.cot_identificador,
          cot_cliente: formClientes.cli_id,
          cot_fecha: formCotCotizacion.cot_fecha,
          cot_vendedor: usr_id,
          cot_descripcion: formCotCotizacion.cot_descripcion,
          cot_garantia:formCotCotizacion.cot_garantia,
          cot_garantia_name:formCotCotizacion.cot_garantia_name,
          cot_sucursal:usr_sucursal,
          cot_validez:formCotCotizacion.cot_validez,
        },
        dataCotizacionDetalle: dataCOT_detail,
      };


      var result = post_cot_cotizacion(body);
      result.then((data) => {
        setError("");
        if(data===true)
        {
          setSaveI(false);
          setBasicModal(false);
          fetch_cot_cotizacion();
          setLoading(false)
        }
        else
          setError("ERROR "+data);
      });

    } else {
      setError("Campos vacios");
    }
  };

  const toggleSaveEncabezado = () => {
    var body = {
      cot_garantia:formCotCotizacion.cot_garantia,
      cot_garantia_name:formCotCotizacion.cot_garantia_name,
      cot_validez:formCotCotizacion.cot_validez,
      cot_fecha:formCotCotizacion.cot_fecha,
      cot_id:formCotCotizacion.cot_id,
      cot_descripcion:formCotCotizacion.cot_descripcion,
      cot_cliente:formClientes.cli_id,
    };
    put_cot_cotizacion_encabezado(body)
    
    setTimeout(() => {
      fetch_cot_cotizacion()
    }, 1000);
  };
  
  function onChangeCliente(event) {
    const { value, name, type, checked } = event.target;
    setFormClientes({
      ...formClientes,
      [name]: type === "checkbox"
        ? (checked ? "1" : "0")
        : value,
    });
    setError("");
  }

  function onChange(event) {
    const { value, name } = event.target;
    setFormCotCotizacion({
      ...formCotCotizacion,
      [name]: value,
    });
    setError("");
  }

  const onClickSaveCliente = ({isEditing,cli_id}) => {
    setLoading(true)
    var body = {
      cli_nombre: formClientes.cli_nombre,
      cli_direccion: formClientes.cli_direccion,
      cli_telefono: formClientes.cli_telefono,
      cli_telefono2: formClientes.cli_telefono2,
      cli_ruc: formClientes.cli_ruc.trim().toUpperCase(),
      cli_dv: formClientes.cli_dv,
      cli_email: formClientes.cli_email,
      cli_limitc: formClientes.cli_limitc,
      cli_suc:usr_sucursal,
      cli_credito:formClientes.cli_credito,
      cli_retencion:formClientes.re_id,
      cli_exento:formClientes.cli_exento,
      return:false
    };
    if (formClientes.cli_nombre.length > 0) {
      if(isEditing){
         onClickUpdateClient({cli_id, cli_nombre: formClientes.cli_nombre,cli_direccion: formClientes.cli_direccion,cli_telefono2: formClientes.cli_telefono2,  cli_ruc: formClientes.cli_ruc,cli_dv: formClientes.cli_dv,cli_telefono: formClientes.cli_telefono,cli_email: formClientes.cli_email,cli_limitc: formClientes.cli_limitc,cli_credito: formClientes.cli_credito,cli_retencion: formClientes.re_id,cli_exento:formClientes.cli_exento})
         setTabAddClientes(false)
        }
      else{
        if(FIND_DESC(dataCliente,formClientes.cli_ruc,null)){
          setError("Error: Ruc ya esta registrado");
        }
        else{
          var result =   post_cli_cliente(body);
          result.then((data) => {
            setFormClientes({...formClientes,cli_id:data});
          });
          setTimeout(() => {
              fetchCliente();
              setTabAddClientes(false)
              setLoading(false)
            }, 1000);
        }

      }
    } else {
      setError("Campos importantes estan vacios");
    }
  };

  function setFormClientesBlank(){
    setFormClientes(STATES_COT_COTIZACION({staneName:"formClientes"}))
  }
  async function fetchCotdDetalle({print,cotd_identificador,formCotizacion}) {
    var response;
    response = await get_cotd_cotizacion_detail(cotd_identificador);
    setOBJCotizacionDetalle(response);
    if(print){
    print_pdf_cotizacion({cotizacion_detalle:response,formCotizacion})
    }

  }

  const update_cotd_cotizacion_detalle_row = (values, cotd_identificador) => {
    var result = put_cotd_cotizacion_detalle_row(values);
    result.then((data) => {
      setError("");
      if(data===true)
      {
        fetchCotdDetalle({print:false,cotd_identificador,formCotizacion:[]})
      }
      else
        setError("ERROR "+data);
    });
  };

  const onClickUpdateClient = ({cli_id, cli_nombre,cli_direccion,cli_telefono2,  cli_ruc,cli_dv,cli_telefono,cli_email,cli_limitc,cli_credito,cli_retencion,cli_exento}) => {
    setLoading(true)
    var body = {
      cli_id,
      cli_nombre,
      cli_direccion,
      cli_telefono,
      cli_telefono2,
      cli_ruc,
      cli_dv,
      cli_email,
      cli_limitc,
      cli_credito,
      cli_retencion,
      cli_exento,
    };
    if (cli_nombre.length > 0) {
      var result = put_cli_cliente(body);
      result.then((data) => {
        setError("");
        if(data===true)
        {
          fetchCliente();
          setLoading(false);
        }
        else
          setError("ERROR "+data);
      });
    } else {
      setError("Campos importantes estan vacios");
    }
  };

  async function fetchArticuloByUpcRe(art_upc) {
    var response;
    response = await get_articulo_by_code(art_upc,usr_sucursal);
    if (response[0] !== undefined) {
      setFormPrecio({
        art_precio:response[0].art_precio,
        art_precio2:response[0].art_precio2,
        art_precio3:response[0].art_precio3,
      })
      setError_upc("");
      setFormCotCotizacionDetalle({
        ...formCotCotizacionDetalle,
        cotd_articulo:response[0].art_id,
        cotd_cantidad: "1",
        art_upc: response[0].art_upc,
        art_descripcion: response[0].art_descripcion,
        cotd_precio:response[0].art_precio,
        art_itbm_cod_v: response[0].art_itbm_cod_v,
        art_itbm_venta:response[0].art_itbm_venta,
        art_imgName:response[0].art_imgName,
        art_img:response[0].art_img,
        art_referencia:response[0].art_referencia,
      });
    } else {
      setError_upc("Articulo no existe");
    }
  }
  
  var ObjClientes = [];
  dataCliente.map((item) => {
    ObjClientes.push({
      value: item.cli_id,
      label: item.cli_nombre + " " + item.cli_ruc,
      ruc: item.cli_ruc,
      email: item.cli_email,
      dv: item.cli_dv,
      objName: "cliente",
    });
  });

  var enableTab = true;
  if (formClientes.cli_id.length > 0) {
    enableTab = false;
  }
 async function onClickBuscarRuc({ruc,is_modal_ruc}){
    if(ruc.length>0){
      var result = await consultar_ruc({ruc})
        if(result.ConsultarRucDVResult.codigo==="200"){
          setFormClientes({...formClientes,cli_nombre: result.ConsultarRucDVResult.infoRuc.razonSocial,
          cli_ruc: result.ConsultarRucDVResult.infoRuc.ruc,
          cli_dv: result.ConsultarRucDVResult.infoRuc.dv})
        }
        else{
           setFormClientes({...formClientes,cli_nombre: "",
         cli_ruc: result?.ConsultarRucDVResult?.infoRuc?.ruc ?? '',
          cli_dv: result?.ConsultarRucDVResult?.infoRuc?.dv ?? '',
        })
           setError("RUC: "+ruc+" No se encontro resultados")
        }
      }
   };
  function setPrecio(art_precio) {
    setFormCotCotizacionDetalle({
      ...formCotCotizacionDetalle,
      cotd_precio: art_precio,
    }); 
  };

  const handleOnChangeCheckBox = (event) => {
    const { value, name } = event.target;
    setFormClientes({
      ...formClientes,
      [name]:value==="0"?"1":"0"
  })
  };

  return (
    <>
      {basicModal && (
        <CotizacionModal
          formCotizacion={formCotCotizacion}
          isOpen={basicModal}
          toggle={setBasicModal}
          onChange={onChange}
          error={error}
          error_upc={error_upc}
          basicModalEdit={basicModalEdit}
          OBJCotizacionDetalle={OBJCotizacionDetalle}
          formCotCotizacionDetalle={formCotCotizacionDetalle}
          propsDropdown={ObjClientes}
          toggleSave={onClickSaveCotizacion}
          onChangeCot_detail={onChangeCot_CotizacionDetalle}
          handleKeyPress={handleKeyPress}
          onBlurs={onBlurF}
          isSaveI={isSaveI}
          deleteRow={deleteRow}
          setOBJCotizacionDetalle={setOBJCotizacionDetalle}
          fetch_cot_cotizacion={fetch_cot_cotizacion}
          update_cotd_cotizacion_detalle_row={update_cotd_cotizacion_detalle_row}
          toggleSaveEncabezado={toggleSaveEncabezado}
          selectCliente={selectCliente}
          dataCliente={dataCliente}
          formClientes={formClientes}
          onChangeCliente={onChangeCliente}
          setFormClientesBlank={setFormClientesBlank}
          onClickSaveCliente={onClickSaveCliente}
          selectItem={fetchArticuloByUpcRe}
          dataItems={dataItems}
          isTabAddClientes={isTabAddClientes}
          setTabAddClientes = {setTabAddClientes}
          setFormClientes={setFormClientes}
          setError={setError}
          usr_precio={usr_precio}
          setPrecio={setPrecio}
          formPrecio={formPrecio}
          handleOnChangeCheckBox={handleOnChangeCheckBox}
          loading={loading}
          dataGarantia={dataGarantia}
          formCotCotizacion={formCotCotizacion}
          dataRetencion={dataRetencion}
          setFormCotCotizacion={setFormCotCotizacion}
          dataCompania={dataCompania}
          onClickBuscarRuc={onClickBuscarRuc}
          fetchCotdDetalle={fetchCotdDetalle}
          dataItbms={dataItbms}
        />
      )}
        <div className="cfg-admin font-s12px">
          <header className="cfg-header">
            <div className="cfg-header-info">
              <h1 className="cfg-title">Cotizaciones</h1>
              <p className="cfg-subtitle">Administración de cotizaciones</p>
            </div>
            <MDBTabs className="cfg-tabs">
              <MDBTabsItem>
                <MDBTabsLink onClick={() => handleIconsClick("tab1")} active={iconsActive === "tab1"}>
                  <MDBIcon fas icon="clipboard-list" className="me-2" /> Cotizaciones
                </MDBTabsLink>
              </MDBTabsItem>
            </MDBTabs>
            <NavLink tag={RRNavLink} to="/user/home" className="cfg-close" title="Cerrar">
              <img src={CLOSE_IMAGE} alt="Cerrar" />
            </NavLink>
          </header>
          <MDBTabsContent className="cfg-content">
            <MDBTabsPane show={iconsActive === "tab1"} >
              {/* <Container fluid className="cfg-panel font-s12px" > */}
              <div className="cfg-card modal-add-inventario datatable-factura css_datatable1">
                <DATATABLE_COTIZACION dataCotizacion={dataCotizacion} onClickDeleteCotizacion_sts={onClickDeleteCotizacion_sts} setBasicModalEdit={setBasicModalEdit} 
                setBasicModal={setBasicModal} setFormCotCotizacion={setFormCotCotizacion} fetchCotdDetalle={fetchCotdDetalle} 
                setFormClientesBlank={setFormClientesBlank} setFormClientes={setFormClientes} setPrintI={setPrintI} onClickNuevaCotizacion={onClickNuevaCotizacion}
                 fetch_cot_cotizacion={fetch_cot_cotizacion} formClientes={formClientes} dataRetencion={dataRetencion}/>
              </div>
                  {/* </Container> */}
            </MDBTabsPane>
          </MDBTabsContent>
        </div>

    </>
  );
};
